import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  CONSENT_URL,
  NEW_DASHBOARD_URL,
  DOCUMENTS_URL,
  HOME_URL,
  LOGIN_URL,
  LOGOUT_URL2,
  MESSAGING_URL,
  CASES_URL,
  SERVICEINIT_URL,
  BATCHINIT_URL,
  HELP_URL,
  EMPLOYEES_URL,
  PROFILE_URL,
  WHAT_IF_URL,
  ASSIGNMENTS_URL,
  CASE_DATA_COLLECT_URL,
} from 'src/constants/constants.js';
import { applyThemeClassName } from 'src/helpers';

/* main features */
import Consent from 'src/ui/features/Consent';
import Documents from 'src/ui/features/Documents';
import Home from 'src/ui/features/Home';
import Login from 'src/ui/features/Login';
import Messaging from 'src/ui/features/Messaging';
import Cases from 'src/ui/features/Cases';
import ServiceInit from 'src/ui/features/ServiceInit';
import Help from 'src/ui/features/Help';
import Employees from 'src/ui/features/Employees';
import Profile from 'src/ui/features/Profile';
import WhatIf from 'src/ui/features/WhatIf';
import Assignments from 'src/ui/features/Assignments';
import { routeChange } from './metrics/metricAction';
import { history, store } from './store/configureStore';
import NewDashboard from './new-ui/features/NewDashboard';
import CaseDataCollect from './new-ui/features/CaseDataCollect';

let prevLocation = {};
history.listen(location => {
  if (location.pathname !== prevLocation.pathname) {
    store.dispatch(routeChange(location));
    prevLocation = location;
  }
  applyThemeClassName();
});
applyThemeClassName();

let routes = (
  <Switch key="router" history={history}>
    <Route path={CONSENT_URL} component={Consent} />
    <Route path={CASE_DATA_COLLECT_URL} component={CaseDataCollect} />
    <Route path={NEW_DASHBOARD_URL} component={NewDashboard} />
    <Route path={DOCUMENTS_URL} component={Documents} />
    <Route path={HOME_URL} component={Home} />
    <Route path={MESSAGING_URL} component={Messaging} />
    <Route path={CASES_URL} component={Cases} />
    <Route path={HELP_URL} component={Help} />
    <Route path={SERVICEINIT_URL} component={ServiceInit} />
    <Route path={BATCHINIT_URL} component={ServiceInit} />
    <Route path={EMPLOYEES_URL} component={Employees} />
    <Route path={PROFILE_URL} component={Profile} />
    <Route path={WHAT_IF_URL} component={WhatIf} />
    <Route path={ASSIGNMENTS_URL} component={Assignments} />
    <Route path={LOGIN_URL} component={Login} />
    <Route path="*" component={props => <Redirect to={LOGIN_URL} />} />
  </Switch>
);

if (sessionStorage.getItem('CN')) {
  routes = (
    <Switch key="router" history={history}>
      <Route path={CONSENT_URL} component={Consent} />
      <Route path={LOGOUT_URL2} component={Login} />
      <Route path="*" component={props => <Redirect to={LOGOUT_URL2} />} />
    </Switch>
  );
}

export default routes;
